import { Pipe, PipeTransform } from '@angular/core';

import { Money } from '@bpos';

@Pipe({
    name: 'msMyBetsMoneyPipe',
    standalone: false,
})
export class MyBetsMoneyPipe implements PipeTransform {
    transform(money: Money | undefined): string {
        if (!money) {
            return '-';
        }

        return `${money.value.toFixed(2)} ${money.currency}`;
    }
}
